<div class="section">
    <span class="page-sub-title" *ngIf="isSection && length !==0">
        {{title | localize}}
        <app-bubble-counter *ngIf="isShowCounter" [isNew]="isNew" [badgeCounter]="length || 0"></app-bubble-counter>
    </span>
    <div class="cards-list">
        <ng-content></ng-content>
    </div>
</div>
